import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";
import Modal from "react-modal";
import { Checkbox } from "antd";

const ComplianceConfigForm = (props) => {
  const frmRef = useRef({});
  const [headName, setHeadName] = useState();
  const [data, setData] = useState("");
  const [filterdData, setFilterdData] = useState("");
  const [complianceCompulsion, setComplianceCompulsion] = useState(false);
  const [remarkJustification, setRemarkJustification] = useState(false);

  const [controlType, setControlType] = useState("");
  const complianceRef = useRef({});
  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
    },
    content: {
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "400px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const [isOpen, setIsOpen] = useState(false);
  const [itemName, setItemName] = useState("");
  const [itemList, setItemList] = useState([]);

  const openType = () => {
    setIsOpen(true);
  };

  const closeType = () => {
    setIsOpen(false);
  };

  const addItemToList = (e) => {
    e.preventDefault();

    const newItem = frmRef.current["itemName"].value;
    if (!itemList.includes(newItem)) {
      setItemList((prevItemList) => [...prevItemList, newItem]);
      frmRef.current["itemName"].value = "";
    } else {
      toast.error("Item already exists in the list");
    }

    closeModal();
  };

  const { sendRequest: postCompConfig } = useHttp();

  const submitComplianceHead = (e) => {
    e.preventDefault();
    const data = {
      serviceId: complianceRef.current.service_name.value,
      complianceHeadName: complianceRef.current.compliance_head.value,

      createdBy: parseInt(localStorage.getItem("id")),
      orgId: parseInt(localStorage.getItem("orgId")),
      serviceId: props.sId,
    };
    //console.log(data);
    postCompConfig(
      {
        url: "/api/serviceWiseComplianceHead/",
        method: "POST",
        body: data,
      },
      (data) => {
        // //console.log(data);
        toast.success(`Compliance Config Done successfully`);

        setIsModalOpen(false);
        frmRef.current.service_name.value = "";
      }
    );
  };

  const { sendRequest: PostComplianceHead } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    const data = {
      swcHeadId: frmRef.current.compliance_head_name.value,
      complianceFieldName: frmRef.current.complianceFieldName.value,
      controlType: frmRef.current.controlType.value,
      itemList: itemList,
      complianceCompulsion: complianceCompulsion,
      remarkJustificationCompulsion: remarkJustification,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: parseInt(localStorage.getItem("orgId")),
      serviceId: props.sId,
    };
    // //console.log(data);
    PostComplianceHead(
      {
        url: "/api/serviceWiseComplianceHeadList/",
        method: "POST",
        body: data,
      },
      (data) => {
        // //console.log(data);
        toast.success(`serviceWise Compliance HeadList add successfully`);
        getAllData();

        closeModal();
        frmRef.current.service_name.value = "";
        frmRef.current.compliance_head_name.value = "";
        frmRef.current.complianceFieldName.value = "";
        frmRef.current.controlType.value = "";
        frmRef.current.complianceCompulsion.checked = false;
        frmRef.current.remarkJustification.checked = false;
      }
    );
  };

  const { sendRequest: getComplianceHead } = useHttp();

  const handleServiceChange = (e) => {
    const id = e.target.value;

    //console.log(id);

    getComplianceHead(
      {
        url: `/api/serviceWiseComplianceHead/?serviceId=${id}&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        // //console.log(res);
        setHeadName(res);
      }
    );
  };

  const { sendRequest: getData } = useHttp();

  const getAllData = () => {
    getData(
      {
        url: `/api/serviceWiseComplianceHeadList/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        // //console.log(res);
        setData(res);
        setFilterdData(res);
      }
    );
  };

  useEffect(() => {
    getAllData();
  }, []);

  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const offset = currentPage * itemsPerPage;
  const displayedItems =
    filterdData && filterdData.slice(offset, offset + itemsPerPage);

  const Services = (option) => {
    switch (option) {
      case 1:
        return "GLOBALG.A.P. Compliance";
      case 2:
        return "Internal Inspection";
      case 3:
        return "Farm Inspection";
    }
  };

  const handleSearch = (e) => {
   var filterText = e.target.value.trim().toLowerCase();

    if (!filterText) {
      setFilterdData(data);
    } else {
      var filterdata = data.filter(
        (item) =>
          item.complianceHeadName
            .toLowerCase()
            .includes(filterText.toLowerCase()) ||
          item.complianceFieldName
            .toLowerCase()
            .includes(filterText.toLowerCase()) ||
          item.controlType.toLowerCase().includes(filterText.toLowerCase())
      );

      setFilterdData(filterdata);
    }
  };

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">
                    Add Compliance Configuration Detail
                  </h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Service Name</label>

                        <select
                          id={"serviceName"}
                          required
                          ref={(el) => (frmRef.current["serviceName"] = el)}
                          className="form-control"
                          onChange={handleServiceChange}
                        >
                          <option value="">Select</option>
                          <option value="1">GLOBALG.A.P. Compliance</option>
                          <option value="2">Internal Inspection</option>
                          <option value="3">Farm Inspection</option>
                        </select>
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="form-group">
                        <label> Compliance Head Name</label> &nbsp;
                        <button
                          type="button"
                          className="btn-primary"
                          data-toggle="modal"
                          data-target="#modal-sm"
                          onClick={openModal}
                        >
                          +
                        </button>
                        <select
                          id={"compliance_head_name"}
                          required
                          ref={(el) =>
                            (frmRef.current["compliance_head_name"] = el)
                          }
                          className="form-control"
                        >
                          <option value="">Select</option>
                          {headName &&
                            headName.map((x) => (
                              <option key={x.swcHeadId} value={x.swcHeadId}>
                                {x.complianceHeadName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Control Type</label>

                        <select
                          id={"controlType"}
                          required
                          ref={(el) => (frmRef.current["controlType"] = el)}
                          className="form-control"
                          onChange={(e) => setControlType(e.target.value)}
                        >
                          <option value="">Select</option>
                          <option value="TextBox">TextBox</option>
                          <option value="List">List</option>
                          <option value="RadioButton">Radio Button</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      {controlType === "List" ||
                      controlType === "RadioButton" ? (
                        <div
                          className="flexColumn"
                          style={{ marginTop: "20px" }}
                        >
                          <button
                            type="button"
                            className="btn  btn-primary mx-2 my-2"
                            onClick={openType}
                          >
                            Add Paramter Detail
                          </button>
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label>Compliance Field Name</label>
                      <textarea
                        id={"complianceFieldName"}
                        required
                        ref={(el) =>
                          (frmRef.current["complianceFieldName"] = el)
                        }
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      <div className="input-check">
                        <input
                          type="checkbox"
                          id={"complianceFieldName"}
                          ref={(el) =>
                            (frmRef.current["complianceCompulsion"] = el)
                          }
                          onChange={(e) =>
                            setComplianceCompulsion(e.target.checked)
                          }
                          value={complianceCompulsion}
                          className="form-check-input"
                        />
                        <label
                          htmlFor={"complianceCompulsion"}
                          className="form-check-label"
                        >
                          {"Compliance Compulsion"}
                        </label>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div>
                      <input
                      type="checkbox"
                        id={"remarkJustification"}
                        ref={(el) =>
                          (frmRef.current["remarkJustification"] = el)
                        }
                        onChange={(e) =>
                          setRemarkJustification(e.target.checked)
                        }
                        value={remarkJustification}
                        className="form-check-input"
                     />
                       
                        <label
                          htmlFor={"Remark Justification Compulsion"}
                          className="form-check-label"
                        >
                          {"Remark Justification Compulsion"}
                        </label>
                        </div>
                     
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-4"></div>
                    <div className="col-md-4"></div>
                  </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Submit
                      </button>
                    </div>
                    <div className="col-md-1">
                      {/* <button className="btn  btn-primary mx-2 my-2" type="submit">
                Cancel
              </button> */}
                    </div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>

      <Modal
        isOpen={isModalOpen}
        style={customModalStyles}
        contentLabel="Example Modal"
      >
        <div>
          <form onSubmit={submitComplianceHead} className="text-center">
            <h3 className="card-title">Compliance Head Name </h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
            <div className="row text-center">
              <div className="col-md-8">
                <label>Service Name</label>
                <select
                  id={"serviceName"}
                  required
                  ref={(el) => (complianceRef.current["service_name"] = el)}
                  className="form-control"
                >
                  <option value="">Select</option>
                  <option value="1">GLOBALG.A.P. Compliance </option>
                  <option value="2">Internal Inspection</option>
                  <option value="3">Farm Inspection</option>
                </select>
              </div>
            </div>

            <div className="row">
              <div className="col-md-8">
                <label> Compliance Head Name</label>
                <input
                  type={"input"}
                  id={"Compliance Head Name"}
                  required
                  ref={(el) => (complianceRef.current["compliance_head"] = el)}
                  className="form-control"
                />
              </div>
            </div>

            <br />
            <div className="text-center">
              <button className="btn  btn-primary mx-2 my-2" type="submit">
                submit
              </button>
            </div>
          </form>
        </div>
      </Modal>

      <Modal
        isOpen={isOpen}
        style={customModalStyles}
        contentLabel="Example Modal"
      >
        <h3 className="card-title">Paramter Details</h3>
        <div className="card-tools text-right">
          <button
            type="button"
            className="btn btn-tool"
            data-card-widget="remove"
            onClick={() => setIsOpen(false)}
          >
            <i className="fas fa-times" />
          </button>
          <hr />
        </div>

        <div>
          <form onSubmit={addItemToList}>
            <div className="row">
              <div className="form-group">
                <label>Parameter Name</label>
                <input
                  type="text"
                  id={"itemName"}
                  required
                  ref={(el) => (frmRef.current["itemName"] = el)}
                  className="form-control"
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-3"> </div>
              <div className="col-md-3">
                <button className="btn  btn-primary mx-2 my-2" type="submit">
                  Add
                </button>
              </div>
            </div>

            <div className="row">
              <table className="table table-bordered text-center">
                <thead>
                  <tr className="tableheaderrowview">
                    <th>Sr.No</th>
                    <th>Item Name</th>
                    <th>Edit</th>
                  </tr>
                </thead>
                <tbody>
                  {itemList.map((items, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{items}</td>
                      <td className="text-center">
                        <button className="list-edit">
                          {" "}
                          <i className="fas fa-edit"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </form>
          <div></div>
        </div>
      </Modal>
    </>
  );
};

export default ComplianceConfigForm;
